// Modules
import React from 'react';

// Components
import ToolTip from "Generic/ToolTip";
import { Position as TooltipPosition } from "Generic/ToolTip/ToolTip";

// Interfaces

// Styles
import "./AppliedPtsInput.sass";

// @ts-ignore
import { LocalizationContext } from "react-localize";

type AppliedPtsInputState = {
  showMaxTooltip: boolean;
};

type Props = {
  onChange(val: number): void;
  value: number;
  maxValue: number;
  id: string;
  disabled: boolean;
};

class AppliedPtsInput extends React.Component<Props,AppliedPtsInputState> {
  constructor(props: Props) {
    super(props);
    this.state = {
      showMaxTooltip: false,
    };
  }

  /**
   * used to toggle the tooltip indicating entered value is greated than max
   */
  toggleMaxTooltip(showMaxTooltip: boolean) {
    this.setState({
      showMaxTooltip,
    })
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.value > this.props.maxValue && !this.state.showMaxTooltip) {
      this.toggleMaxTooltip(true);
    } else if (this.props.value <= this.props.maxValue && this.state.showMaxTooltip) {
      this.toggleMaxTooltip(false);
    }
  }

  /**
   * Fired when the applied points input is edited.
   * Use regex to strip input to only integers.
   * If input exceeds maxValue in props, show tooltip
   */
  onChange(value: any) {
    const {maxValue, onChange} = this.props;

    let intOnlyRegex = value.replace(/[^0-9]/g, "");

    if (intOnlyRegex.length === 0) {
      intOnlyRegex = 0;
    }

    intOnlyRegex = parseInt(intOnlyRegex);

    this.toggleMaxTooltip(value > maxValue);

    onChange(intOnlyRegex);
  }

  render() {
    const { localize } = this.context;

    const {value, id, disabled} = this.props;
    const {showMaxTooltip} = this.state;

    return (
      <div id={id} aria-label={""} className="applied-pts-input">
          {showMaxTooltip &&
            <div className="max-tooltip">
              {localize("static.content.ayp-not-exceed-points")}
            </div>
          }
          <input
            disabled={disabled}
            value={value}
            onChange={(e) => this.onChange(e.target.value)}
          />
      </div>
    );
  }
}

AppliedPtsInput.contextType = LocalizationContext;
export default AppliedPtsInput;
